import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "grid grid-cols-12 gap-5 place-items-center lg:place-items-stretch place-content-center md:h-screen mt-5 md:mt-0" }
const _hoisted_2 = {
  key: 0,
  class: "col-span-12 lg:col-span-6 w-full sm:w-8/12 lg:w-full"
}
const _hoisted_3 = { class: "bg-white shadow-md rounded-xl overflow-hidden lg:m-10" }
const _hoisted_4 = { class: "bg-gray-50 p-5" }
const _hoisted_5 = { class: "px-5 py-5" }
const _hoisted_6 = { class: "flex flex-col my-4" }
const _hoisted_7 = { class: "flex flex-col my-4" }
const _hoisted_8 = { class: "flex flex-col my-4" }
const _hoisted_9 = { class: "flex flex-col my-4" }
const _hoisted_10 = { class: "flex justify-start flex-wrap gap-1" }
const _hoisted_11 = {
  for: "binary",
  class: "font-[600]"
}
const _hoisted_12 = { class: "bg-gray-50 p-4 flex justify-end items-center mt-3 border-t border-t-gray-300 rounded-b-lg" }
const _hoisted_13 = {
  key: 1,
  class: "hidden lg:flex justify-end lg:col-span-6 lg:m-40"
}
const _hoisted_14 = {
  key: 2,
  id: "sign-up-error",
  class: "col-span-12"
}
const _hoisted_15 = { class: "flex justify-center items-center" }
const _hoisted_16 = { class: "bg-white shadow-sm rounded-md border border-gray-300 md:w-5/12" }
const _hoisted_17 = { class: "bg-gray-50 border-b border-gray-300 p-4" }
const _hoisted_18 = { class: "flex flex-col justify-center items-center gap-3 my-10" }
const _hoisted_19 = ["innerHTML"]
const _hoisted_20 = { class: "bg-gray-50 flex justify-end items-center mt-3 border-t border-t-gray-300 rounded-b-lg p-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Errors = _resolveComponent("Errors")!
  const _component_InputMask = _resolveComponent("InputMask")!
  const _component_InputPassword = _resolveComponent("InputPassword")!
  const _component_Button = _resolveComponent("Button")!
  const _component_ComputerComponent = _resolveComponent("ComputerComponent")!
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.hasError)
      ? (_openBlock(), _createElementBlock("section", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("h4", null, _toDisplayString(_ctx.$t("labels.generic", {
                pt: "Registre-se como aluno",
                en: "Register as a student",
              })), 1)
            ]),
            _createElementVNode("form", {
              onSubmit: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_ctx.sendEmailToUser()), ["prevent"]))
            }, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_InputText, {
                    id: "name-input",
                    type: "text",
                    modelValue: _ctx.form.name,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.name) = $event)),
                    placeholder: 
                  _ctx.$t('labels.generic', { pt: 'Nome completo', en: 'Full name' })
                ,
                    class: _normalizeClass(_ctx.v$.form.name.$error ? 'p-invalid' : '')
                  }, null, 8, ["modelValue", "placeholder", "class"]),
                  _createVNode(_component_Errors, {
                    errors: _ctx.v$.form.name.$errors
                  }, null, 8, ["errors"])
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_component_InputMask, {
                    id: "cpf-input",
                    mask: "999.999.999-99",
                    modelValue: _ctx.form.cpf,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.cpf) = $event)),
                    placeholder: "CPF",
                    class: _normalizeClass(_ctx.v$.form.cpf.$error ? 'p-invalid' : '')
                  }, null, 8, ["modelValue", "class"]),
                  _createVNode(_component_Errors, {
                    errors: _ctx.v$.form.cpf.$errors
                  }, null, 8, ["errors"])
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_InputPassword, {
                    id: "password-input",
                    modelValue: _ctx.form.password,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.password) = $event)),
                    feedback: false,
                    toggleMask: "",
                    placeholder: 
                  _ctx.$t('labels.generic', { pt: 'Senha', en: 'Password' })
                ,
                    class: _normalizeClass(_ctx.v$.form.password.$error ? 'p-invalid' : '')
                  }, null, 8, ["modelValue", "placeholder", "class"]),
                  _createVNode(_component_Errors, {
                    errors: _ctx.v$.form.password.$errors
                  }, null, 8, ["errors"])
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(_component_InputPassword, {
                    id: "confirm-password-input",
                    modelValue: _ctx.form.confirmPassword,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.confirmPassword) = $event)),
                    feedback: false,
                    toggleMask: "",
                    placeholder: 
                  _ctx.$t('labels.generic', {
                    pt: 'Confirmar senha',
                    en: 'Confirm password',
                  })
                ,
                    class: _normalizeClass(_ctx.v$.form.confirmPassword.$error ? 'p-invalid' : '')
                  }, null, 8, ["modelValue", "placeholder", "class"]),
                  _createVNode(_component_Errors, {
                    errors: _ctx.v$.form.confirmPassword.$errors
                  }, null, 8, ["errors"])
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("label", _hoisted_11, _toDisplayString(_ctx.$t("labels.generic", {
                    pt: "Já tem uma conta? Faça o",
                    en: "Already have an account?",
                  })), 1),
                  _createElementVNode("a", {
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.go.redirectTo('sign-in'))),
                    class: "text-h-primary-500 hover:text-h-primary-700 cursor-pointer font-[700]"
                  }, " Login ")
                ])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createVNode(_component_Button, {
                  type: "submit",
                  label: "Enviar",
                  class: "btn-primary"
                })
              ])
            ], 32)
          ])
        ]))
      : _createCommentVNode("", true),
    (!_ctx.hasError)
      ? (_openBlock(), _createElementBlock("section", _hoisted_13, [
          _createVNode(_component_ComputerComponent, { icon: "md-assignmentind-twotone" })
        ]))
      : _createCommentVNode("", true),
    (_ctx.hasError)
      ? (_openBlock(), _createElementBlock("section", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("h4", null, _toDisplayString(_ctx.$t("labels.generic", {
                  pt: "Link expirado ou inválido",
                  en: "Expired or invalid link",
                })), 1)
              ]),
              _createElementVNode("div", _hoisted_18, [
                _createVNode(_component_v_icon, {
                  name: "md-announcement-twotone",
                  class: "text-h-primary-500 my-5",
                  scale: "8"
                }),
                _createElementVNode("p", {
                  class: "px-8 md:px-10 text-center text-lg",
                  innerHTML: 
                _ctx.$t('labels.generic', {
                  pt: 'Seu Link expirou, <strong>foi enviado um novo e-mail</strong> para completar o cadastro!',
                  en: 'Your Link has expired, <strong>a new email has been sent</strong> to complete the registration!',
                })
              
                }, null, 8, _hoisted_19)
              ]),
              _createElementVNode("div", _hoisted_20, [
                _createVNode(_component_Button, {
                  id: "login",
                  label: 'Voltar para o login',
                  class: "btn-primary",
                  onClick: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (_ctx.go.redirectTo('sign-in')), ["prevent"]))
                })
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}